import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/CreateTeacherPage.css'; 
import { useNavigate, useParams } from 'react-router-dom'; 

function StockCreatePage({ isSidebarCollapsed }) {
  const [errors, setErrors] = useState({});
  const [selectedType, setSelectedType] = useState('');
  const navigate = useNavigate();
  const { inventoryId } = useParams();

  const [formData, setFormData] = useState({
    teacher_name: '',
    birth_date: '',
    branch_id: '',
    role_id: '',
    phone_number: '',
    address: '',
    price: '0',
    join_date: '',
  });

  const formatCurrency = (amount) => {
    return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
  };

  const handlePriceChange = (e) => {
    const value = e.target.value.replace(/\./g, ''); // Hapus titik dari input
    setFormData({ ...formData, price: value }); // Simpan nilai asli
    e.target.value = formatCurrency(value); // Format dan set nilai input
  };

  useEffect(() => {
   
    if (inventoryId) {
      api.get(`/inventory/detail/${inventoryId}`)
        .then(response => {
          const data = response.data.data[0]; // Sesuaikan dengan struktur respons API Anda
          setFormData({
            item_name: data.item_name,
            item_type: data.item_type,
            price: data.price
          });
        })
        .catch(error => console.error('Error fetching teacher profile:', error));
    }
  }, [inventoryId]);

  const validateForm = (formData) => {
    const errors = {};
    if (!formData.item_name) errors.item_name = 'Item Name is required';
    if (!formData.item_type) errors.item_type = 'Item Type is required';
    if (!formData.price) {
      errors.price = 'Price is required';
    } else if (!/^\d+$/.test(formData.price)) {
      errors.price = 'Price must contain only numbers';
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Validation Errors:', validationErrors);
    } else {
      const confirmation = window.confirm('Are you sure you want to proceed with this action?');
      if (!confirmation) {
        return;
      }

      const requestBody = {
        data: {
          inventoryData: formData,
        }
      };

      const apiCall = inventoryId ? 
        api.put(`/inventory/stockUpdate/${inventoryId}`, requestBody) : 
        api.post('/inventory/stockSave', requestBody);


      apiCall
        .then(response => {
          const successMessage = response.data.message;
          console.log(successMessage);
          navigate('/success', { state: { message: successMessage } });
        })
        .catch(error => {
          console.error('Error adding/updating teacher:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    }
  };

  return (
    <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="page-title">{inventoryId ? 'Edit Stock' : 'Create New Stock'}</div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="section">
            <h3 className="section-header">Item Data</h3>
            <label>Item Name</label>
            <input 
              type="text" 
              name="item_name" 
              value={formData.item_name} 
              onChange={e => setFormData({ ...formData, item_name: e.target.value })} 
              disabled={!!inventoryId} // Disable jika dalam mode edit
            />
            {errors.item_name && <div className="error-message">{errors.item_name }</div>}

            <label>Item Type</label>
            <select
                value={selectedType}
                onChange={e => setFormData({ ...formData, item_type: e.target.value })} 
            >
                <option value="">Select Type</option>
                <option value="BOOK">BOOK</option>
                <option value="OTHERS">OTHERS</option>
            </select>
            {errors.selectedType && <div className="error-message">{errors.selectedType}</div>}

            <label>Price</label>
            <input 
              type="text" 
              name="price" 
              value={formatCurrency(formData.price)} 
              onChange={handlePriceChange} 
            />
            {errors.price && <div className="error-message">{errors.price}</div>}
          </div>

          <div className="search-container">
            <table>
              <tr>
                <td>
                  <button className="profile-button" type="submit">{inventoryId ? 'Update' : 'Submit'}</button>  
                </td>
              </tr>
              <tr>
                <td>
                  <button className="profile-button" onClick={() => navigate('/teacher-list')}>Back</button>
                </td>
              </tr>
            </table>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StockCreatePage;
